import { Component, OnInit, Input } from '@angular/core';
import { SKU2Parts } from '@core/services/data.service';

@Component({
  selector: 'good',
  templateUrl: './good.component.html',
  styleUrls: ['./good.component.scss']
})
export class GoodComponent implements OnInit {

  @Input()
  public sku: string;

  private _producer: string = '';
  private _code: string = '';


  public get producer(): string {
    return this._producer.length > 1 ? this._producer + '-' : this._producer;
  }

  public get code(): string {
    return this._code;
  }

  constructor() { }

  ngOnInit(): void {
    let parts = SKU2Parts(this.sku);
    this._producer = parts[0];
    this._code = parts[1];
  }

}
